import { password as passwordPattern, url as urlPattern } from '@/utils/patterns'
export default {
  methods: {
    checkNewPassword (rule, value, callback) {
      if (!passwordPattern.test(value)) {
        callback(new Error(this
          .$i18n.t('password_validator')))
      } else {
        callback()
      }
    },
    checkUrl (rule, value, callback) {
      if (!urlPattern.test(value)) {
        callback(new Error(this
          .$i18n.t('url_validator')))
      } else {
        callback()
      }
    },
    validateAndSubmitForm (formName, callback) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          callback()
        } else {
          return false
        }
      })
    }
  }
}
